import React, { useEffect, useLayoutEffect, useState } from "react";
import { FiX } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import {
  getIngredients,
  RESET_INGREDIENT,
  selectIngredients,
  selectIngredientSuccessCreateUpdate,
  updateIngredient,
} from "../../redux/features/ingredient/IngredientSlice";
import { MdEdit } from "react-icons/md";
import {
  getAllUOMs,
  selectUnitOfMeasures,
} from "../../redux/features/unitOfMeasure/UnitOfMeasureSlice";

const EditIngredient = ({ id }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [ingredientName, setIngredientName] = useState("");
  const [ingredientQuantity, setIngredientQuantity] = useState();
  const [inventoryUnit, setInventoryUnit] = useState("");
  const [conversionRate, setConversionRate] = useState();
  const [purchaseUnit, setPurchaseUnit] = useState("");

  const [errors, setErrors] = useState({});
  const ingredients = useSelector(selectIngredients);
  const ingredient = ingredients?.find((ingredient) => ingredient?._id === id);

  const handleOpen = () => setIsOpen(true);
  const handleClose = () => {
    setIngredientQuantity();
    setIsOpen(false);
    setErrors({});
  };

  useLayoutEffect(() => {
    if (ingredient) {
      setIngredientName(ingredient?.name);
      setConversionRate(ingredient?.conversionRate);
      setInventoryUnit(ingredient?.inventoryUnit);
      setPurchaseUnit(ingredient?.purchaseUnit);
    }
  }, [ingredient]);

  const validateForm = () => {
    const newErrors = {};
    if (!ingredientName) newErrors.ingredientName = "Name is required";
    if (!inventoryUnit) newErrors.inventoryUnit = "Inventory Unit is required";
    if (!purchaseUnit) newErrors.purchaseUnit = "Purchase Unit is required";

    if (!conversionRate)
      newErrors.conversionRate = "Conversion Rate is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const dispatch = useDispatch();
  const isSuccess = useSelector(selectIngredientSuccessCreateUpdate);
  const unitOfMeasures = useSelector(selectUnitOfMeasures);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    const updateIngredientData = {
      id,
      ingredientName,
      quantity: Number(ingredientQuantity),
      inventoryUnit,
      purchaseUnit,
      conversionRate: Number(conversionRate),
    };

    await dispatch(updateIngredient(updateIngredientData));
  };

  useEffect(() => {
    if (isSuccess) {
      handleClose();
      dispatch(getIngredients());
      dispatch(RESET_INGREDIENT());
    }
  }, [isSuccess, dispatch]);

  useEffect(() => {
    dispatch(getAllUOMs());
  }, [dispatch]);

  return (
    <div>
      {/* Button to open the modal */}
      <button
        onClick={handleOpen}
        className="bg-[#0D868C] text-center text-white p-1 rounded-lg cursor-pointer"
      >
        <MdEdit className="lg:size-6 size-5" />
      </button>

      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white shadow-xl rounded-[10px] md:w-[650px] w-[90%] mx-auto p-10 space-y-6">
            <div className="flex justify-between items-center border-b-2 border-[#DEDEDE] pb-4 mb-8">
              <h1 className="md:text-[1.75rem] text-[1rem] font-bold text-[#0D868C]">
                Update Ingredient
              </h1>
              <button type="button" onClick={handleClose}>
                <FiX className="md:size-8 size-5 text-[#0D868C]" />
              </button>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="mb-2 flex flex-col items-start">
                <label className="text-[.75rem] font-semibold text-[#7D7D7D]">
                  Ingredient Name
                </label>
                <input
                  value={ingredientName}
                  onChange={(e) => setIngredientName(e.target.value)}
                  type="text"
                  placeholder="Name"
                  className="w-full outline-none text-[1rem] font-normal text-[#A9A9A9] pr-3 pt-2 border-b border-[#0D868C]"
                />
                {errors.ingredientName && (
                  <p className="text-red-500 text-xs">
                    {errors.ingredientName}
                  </p>
                )}
              </div>

              <div className="mb-2 flex flex-col items-start">
                <label className="text-[.75rem] font-semibold text-[#7D7D7D]">
                  Ingredient Quantity
                </label>
                <input
                  type="number"
                  step={0.1}
                  onWheel={(e) => e.target.blur()}
                  value={ingredientQuantity}
                  onChange={(e) => setIngredientQuantity(e.target.value)}
                  placeholder="5,200,100 etc."
                  className="w-full outline-none text-[1rem] font-normal text-[#A9A9A9] pr-3 pt-2 border-b border-[#0D868C]"
                />
              </div>

              <div className="mb-2 flex flex-col items-start">
                <label className="text-[.75rem] font-semibold text-[#7D7D7D]">
                  Inventory Unit
                </label>
                {/* <input
                  type="text"
                  value={inventoryUnit}
                  onChange={(e) => setInventoryUnit(e.target.value)}
                  placeholder="gram,kg etc."
                  className="w-full outline-none text-[1rem] font-normal text-[#A9A9A9] pr-3 pt-2 border-b border-[#0D868C]"
                /> */}

                <select
                  name="inventoryUnit"
                  value={inventoryUnit}
                  onChange={(e) => setInventoryUnit(e.target.value)}
                  className="w-full outline-none text-[1rem] font-normal rounded-none text-[#A9A9A9] pr-3 pt-2 border-b border-[#0D868C] capitalize"
                >
                  <option value="">Select Inventory Unit</option>
                  {unitOfMeasures?.map((unitOfMeasure, index) => (
                    <option
                      key={index}
                      value={unitOfMeasure.name.toLowerCase()}
                      className="capitalize"
                    >
                      {unitOfMeasure.name}
                    </option>
                  ))}
                </select>
                {errors.inventoryUnit && (
                  <p className="text-red-500 text-xs">{errors.inventoryUnit}</p>
                )}
              </div>
              <div className="mb-2 flex flex-col items-start">
                <label className="text-[.75rem] font-semibold text-[#7D7D7D]">
                  Purchase Unit
                </label>
                {/* <input
                  type="text"
                  value={purchaseUnit}
                  onChange={(e) => setPurchaseUnit(e.target.value)}
                  placeholder="gram,kg etc."
                  className="w-full outline-none text-[1rem] font-normal text-[#A9A9A9] pr-3 pt-2 border-b border-[#0D868C]"
                /> */}
                <select
                  name="purchaseUnit"
                  value={purchaseUnit}
                  onChange={(e) => setPurchaseUnit(e.target.value)}
                  className="w-full outline-none text-[1rem] font-normal rounded-none text-[#A9A9A9] pr-3 pt-2 border-b border-[#0D868C] capitalize"
                >
                  <option value="">Select Inventory Unit</option>
                  {unitOfMeasures?.map((unitOfMeasure, index) => (
                    <option
                      key={index}
                      value={unitOfMeasure.name.toLowerCase()}
                      className="capitalize"
                    >
                      {unitOfMeasure.name}
                    </option>
                  ))}
                </select>
                {errors.purchaseUnit && (
                  <p className="text-red-500 text-xs">{errors.purchaseUnit}</p>
                )}
              </div>

              <div className="mb-2 flex flex-col items-start">
                <label className="text-[.75rem] font-semibold text-[#7D7D7D]">
                  Conversion Rate
                </label>
                <input
                  type="number"
                  min={0}
                  step={0.1}
                  onWheel={(e) => e.target.blur()}
                  value={conversionRate}
                  onChange={(e) => setConversionRate(e.target.value)}
                  placeholder="500,1000 etc."
                  className="w-full outline-none text-[1rem] font-normal text-[#A9A9A9] pr-3 pt-2 border-b border-[#0D868C]"
                />
                {errors.conversionRate && (
                  <p className="text-red-500 text-xs">
                    {errors.conversionRate}
                  </p>
                )}
              </div>

              <div className="text-center mt-6">
                <button
                  type="submit"
                  className="text-white bg-[#0D868C] md:w-[50%] w-full py-3 rounded-full outline-none uppercase font-normal text-[1rem]"
                >
                  Update Ingredient
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default EditIngredient;
